<template>
	<div class="flex grow right" :class="prefixCls">
		<div class="flex grow left">
			<slot name="left"></slot>
		</div>
		<slot></slot>
	</div>
</template>
<script>
	export default {
        name:"TableToolBar",
		computed:{
			prefixCls(){
				return 'ivu-table-tool-bar'
			}
		}
	}
</script>